<template>
  <section id="contact">
    <div class="container">
      <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
        <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
        </symbol>
        <symbol id="info-fill" fill="currentColor" viewBox="0 0 16 16">
          <path
            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
        </symbol>
        <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
          <path
            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        </symbol>
      </svg>
      <div class="row">
        <div class="col-xl-8 col-lg-8 col-md-8 col-xm-12">
          <div class="card">
            <div class="card-header">Faites vos paiements</div>
            <div class="card-body">
              <div class="col-12">
                <Form ref="paiementForm" @submit="payer" :validation-schema="paiementSchema">
                  <div id="stepper" class="bs-stepper">
                    <div class="bs-stepper-header">
                      <div class="step" data-target="#step-1" disabled>
                        <button class="btn btn-success step-trigger" disabled>
                          <span class="bs-stepper-circle">1</span>
                          <span class="bs-stepper-label">Information</span>
                        </button>
                      </div>
                      <div class="line"></div>
                      <div class="step" data-target="#step-2" disabled>
                        <button class="step-trigger" disabled>
                          <span class="bs-stepper-circle">2</span>
                          <span class="bs-stepper-label">Facture(s) impayée(s)</span>
                        </button>
                      </div>
                      <div class="line"></div>
                      <div class="step" data-target="#step-3" disabled>
                        <button class="step-trigger" disabled>
                          <span class="bs-stepper-circle">3</span>
                          <span class="bs-stepper-label">Paiement</span>
                        </button>
                      </div>
                    </div>

                    <div class="bs-stepper-content">
                      <div id="step-1" class="content">
                        <h4>
                          Veuillez saisir votre numéro de référence abonné
                        </h4>
                        <div class="row">
                          <div class="col-md-12">
                            <label class="d-block text-black fw-semibold mb-10">
                              Numéro d'identification personnel (NPI)
                              (XXXXXXXXXX)
                            </label>
                            <Field name="reference" type="text" v-model="reference" class="form-control" />
                            <ErrorMessage name="reference" class="text-danger" />
                          </div>
                        </div>
                        <div class="offset-9 mt-10 col-md-3 text-end">
                          <button @click="nextStep(1)" class="btn btn-success" type="button" v-show="valideEtape1">
                            Suiv
                          </button>

                          <button class="btn btn-success" type="button" v-show="!valideEtape1" disabled>
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span class="visually-hidden">Loading...</span>
                          </button>
                        </div>
                      </div>
                      <div id="step-2" class="content">
                        <h3>Facture(s) impayée(s)</h3>
                        <div class="row" v-show="affiche">
                          <div class="col-12">
                            <div class="alert alert-success d-flex align-items-center" role="alert" :style="alertStyle">
                              <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img"
                                aria-label="Success:">
                                <use xlink:href="#check-circle-fill" />
                              </svg>
                              <div>
                                Bravo !!! Vous n'avez aucun impayé à cette date
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="alert alert-info d-flex align-items-center" role="alert" :style="alertStyle">
                              <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="info:">
                                <use xlink:href="#check-circle-fill" />
                              </svg>
                              <div>
                                <table>
                                  <thead>
                                    <tr>
                                      <th scope="col">
                                        <strong>Exploitant : </strong>
                                      </th>
                                      <th scope="col">{{ exploitant }}</th>
                                    </tr>
                                    <tr>
                                      <th scope="col">
                                        <string>Activité : </string>
                                      </th>
                                      <th scope="col">{{ activite }}</th>
                                    </tr>
                                  </thead>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12" v-for="(arrear, index) in lesArrieres" :key="index">
                            <div class="mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between">
                              <h6 class="card-title fw-bold mb-0">
                                PLACE N° {{ arrear.code }}
                              </h6>
                              <div
                                class="card-select mt-10 mt-sm-0 mb-10 mb-sm-0 d-flex align-items-center ps-10 pe-10 pt-5 pb-5">
                                <span class="fw-medium text-muted me-8">TOTAL IMPAYE : {{ arrear.somRedevance }}</span>
                              </div>
                            </div>
                            <div class="table-responsive">
                              <table class="table text-nowrap align-middle mb-0">
                                <thead>
                                  <tr>
                                    <th scope="col"
                                      class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                                      #
                                    </th>
                                    <th scope="col"
                                      class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                      Année
                                    </th>
                                    <th scope="col"
                                      class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                      Loyer
                                    </th>
                                    <th scope="col"
                                      class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                      Nmbre Mois
                                    </th>
                                    <th scope="col"
                                      class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                      Etat
                                    </th>
                                  </tr>
                                </thead>
                                <tbody v-if="arrear.arrieres">
                                  <tr v-for="(imp, index) in arrear.arrieres" :key="index" class="clickable-row">
                                    <th class="shadow-none lh-1 fw-bold ps-0">
                                      {{ index + 1 }}
                                    </th>
                                    <td class="shadow-none lh-1 fw-semibold text-dark">
                                      {{ imp.annee }}
                                    </td>
                                    <td class="shadow-none lh-1 fw-semibold text-dark">
                                      {{ imp.taux }}
                                    </td>
                                    <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                                      {{ imp.anneeEncour == true ? imp.moisDette : imp.mois }}
                                    </td>
                                    <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                                      <span class="badge text-outline-danger">En attente</span>
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody v-else>
                                  <tr>
                                    <th class="shadow-none lh-1 fw-bold ps-0" colspan="4">
                                      AUCUNE IMPAYE TROUVE
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-10">
                          <div class="text-end">
                            <button class="btn btn-warning" type="button" @click="previousStep">
                              Pre
                            </button>
                            <button @click="nextStep(2)" class="btn btn-success" type="submit"
                              style="margin-left: 0.5em" v-show="valideEtape2">
                              Suiv
                            </button>
                            <button class="btn btn-success" type="button" v-show="!valideEtape2" disabled>
                              <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                              <span class="visually-hidden">Chargement...</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div id="step-3" class="content">
                        <h3>Paiement</h3>
                        <div class="accordion" :id="'accordionExample' + index" v-for="(arrear, index) in lesArrieres"
                          :key="index">
                          <div class="accordion-item">
                            <h2 class="accordion-header" :id="'heading' + index">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                :data-bs-target="'#collapse' + index" aria-expanded="false"
                                :aria-controls="'collapse' + index">
                                PLACE N° {{ arrear.code }}
                              </button>
                            </h2>
                            <div :id="'collapse' + index" class="accordion-collapse collapse"
                              :data-bs-parent="'#accordionExample' + index" :aria-labelledby="'heading' + index">
                              <div class="accordion-body">
                                <div
                                  class="card-select mt-10 mt-sm-0 mb-10 mb-sm-0 d-flex align-items-center ps-10 pe-10 pt-5 pb-5">
                                  <span class="fw-medium text-muted me-8">TOTAL IMPAYE : {{ arrear.somRedevance
                                  }}</span>
                                </div>
                                <div class="table-responsive">
                                  <table class="table text-nowrap align-middle mb-0">
                                    <thead>
                                      <tr>
                                        <th scope="col"
                                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                                          #</th>
                                        <th scope="col"
                                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                          Année</th>
                                        <th scope="col"
                                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                          Loyer</th>
                                        <th scope="col"
                                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                          Nmbre Mois</th>
                                        <th scope="col"
                                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                          Etat</th>
                                      </tr>
                                    </thead>
                                    <tbody v-if="arrear.arrieres">
                                      <tr v-for="(imp, index) in arrear.arrieres" :key="index" class="clickable-row">
                                        <th class="shadow-none lh-1 fw-bold ps-0">{{ index + 1 }}</th>
                                        <td class="shadow-none lh-1 fw-semibold text-dark">{{ imp.annee }}</td>
                                        <td class="shadow-none lh-1 fw-semibold text-dark">{{ imp.taux }}</td>
                                        <td class="shadow-none lh-1 fw-medium text-body-tertiary">{{ imp.anneeEncour ==
                                          true ? imp.moisDette : imp.mois }}</td>
                                        <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                                          <span class="badge text-outline-danger">En attente</span>
                                        </td>
                                      </tr>
                                    </tbody>
                                    <tbody v-else>
                                      <tr>
                                        <th class="shadow-none lh-1 fw-bold ps-0" colspan="4">AUCUNE IMPAYE TROUVE</th>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">

                          <div class="col-md-12">
                            <div class="row p-11 border border-info">
                              <div class="col-6 text-end">
                                <Field type="radio" class="btn-check" name="mode" id="kkia" autocomplete="off" value="2"
                                  checked v-model="choix" @click="choixMode(2)" check />
                                <label class="btn btn-outline-success" for="kkia" @click="choixMode(2)">
                                  KKIAPAY
                                </label>
                              </div>
                              <div class="col-6 text-left">
                                <Field type="radio" class="btn-check" name="mode" id="tresor" value="3"
                                  autocomplete="off" :disabled="true" v-model="choix" @click="choixMode(3)" />
                                <label :disabled="true" class="btn btn-outline-success" for="tresor"
                                  @click="choixMode(3)">
                                  TRESOR PAY
                                </label>
                              </div>
                            </div>
                            <div class="row mt-10">
                              <div class="col-12">
                                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                  <label class="d-block text-black fw-semibold mb-10">
                                    Sélectionnez la place à payer<span class="text-danger">*</span>
                                  </label>
                                  <Field name="contrat" v-slot="{ field }" v-model="contr"
                                    class="form-control shadow-none fs-md-15 text-black">
                                    <Multiselect v-model="field.value" v-bind="field" :options="contraOptions"
                                      :searchable="true" noResultText="Aucun enregistrement trouvé"
                                      placeholder="Rechercher un contrat" />
                                  </Field>
                                  <ErrorMessage name="contrat" class="text-danger" />
                                </div>
                              </div>
                            </div>
                            <div class="row mt-10">
                              <div class="col-md-6">
                                <label for="mois" class="form-label fw-medium text-black">
                                  Nombre de mois
                                </label>
                                <Field name="mois" v-model="mois"
                                  class="form-control shadow-none fs-md-15 text-black" />
                                <ErrorMessage name="mois" class="text-danger" />
                              </div>
                              <div class="col-md-6">
                                <label for="montant" class="form-label fw-medium text-black">
                                  Montant
                                </label>
                                <Field name="montant" v-model="montant" :disabled="true"
                                  class="form-control shadow-none fs-md-15 text-black" />
                                <ErrorMessage name="montant" class="text-danger" />
                              </div>
                            </div>
                            <div class="row mt-10">
                              <div class="text-end">
                                <button class="btn btn-warning" type="button" @click="previousStep">
                                  Pre
                                </button>
                                <button class="btn btn-success" type="submit" style="margin-left: 0.5em"
                                  v-show="valideEtape3">
                                  Finaliser
                                </button>
                                <button class="btn btn-success" type="button" v-show="!valideEtape3" disabled>
                                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                  <span class="visually-hidden">Chargement...</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-xm-12">
          <div class="card mb-3" style="max-width: 18rem">
            <div class="card-header bg-light">
              <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Info:">
                <use xlink:href="#info-fill" />
              </svg>
              A propos E-Paie Sogema
            </div>
            <div class="card-body bg-white">
              <h6 class="card-title">Ce dont vous avez besoin</h6>
              <ol class="list-group list-group-numbered bg-light">
                <li class="list-group-item d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">Durée de traitement</div>
                  </div>
                  <span class="badge bg-primary rounded-pill">3 min</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">Le nécessaire</div>
                    <p>- Votre numéro d'identification personnel (NPI)</p>
                    <p>- Un téléphone portable</p>
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">3 étapes clés</div>
                    <p>- Renseignez la référence de votre NPI</p>
                    <p>- Consultez vos impayés</p>
                    <p>- Procédez au paiement en ligne</p>
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">Autre moyen</div>
                    En cas de besoin contacter un agent de la SOGEMA et faites
                    vos dépots sur ces numéros
                    <p>- MTN : 0154668860</p>
                    <p>- MOOV : 0198365375</p>
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">SOGEMA EN LIQUIDATION</div>
                    RDV à la SOGEMA en cas de problème pour être rapidement pris
                    en charge par un agent.
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  ref,
  onMounted,
  watch,
  reactive,
  computed,
  toRef,
  onBeforeUnmount,
} from "vue";
import Stepper from "bs-stepper";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import axios from "axios";
import {
  error,
  nomBreMoisAnneeEntame,
  recuperLesMoisDu,
  success,
  getMonthsWithinRange,
  getUrlApiForFiles,
} from "@/utils/utils";
import { useRouter } from "vue-router";
import {
  openKkiapayWidget,
  addKkiapayListener,
  removeKkiapayListener,
} from "kkiapay";
import { KKIAPAY } from "@/models/KKIAPAY";
import ApiService from "@/services/ApiService";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";


export default {
  name: "FormulairePaiement",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup() {
    const router = useRouter(); // Use the useRouter hook to get the router instance
    const valideEtape1 = ref(true);
    const valideEtape2 = ref(true);
    const valideEtape3 = ref(true);
    const donnee = ref();
    const stepper = ref(null);
    const reference = ref("");
    const paiementSchema = Yup.object().shape({
      reference: Yup.string().notRequired(),
      mois: Yup.string().notRequired(),
      mode: Yup.number().notRequired(),
      montant: Yup.number().notRequired(),
      contrat: Yup.number().notRequired(),
    });
    const contrats = ref([]);
    const contrat = ref(null);
    const montant = ref(0);
    const mois = ref(0);
    const totalDeMoisDuAceJour = ref(0);
    var check = reactive({
      typeError: "RAS",
      idTransaction: 0,
    });

    const contraOptions = ref([]);
    const contr = ref()

    async function successHandler(response, values, { resetForm }) {
      check.typeError = "SUCCESS";
      check.idTransaction = response.transactionId;
      values["idTransaction"] = check.idTransaction;
      values["check"] = check;
      // Bloc de code à exécuter lorsque le paiement est un succès
      if (check.typeError === "SUCCESS") {
        // Appel de la fonction addAbonnement et attente de son exécution
        await finishStep(values, { resetForm });
      } else {
        check.typeError = "RAS";
        check.idTransaction = 0;
      }

      // Retourne les données après l'exécution
      return { check, response };
    }

    async function failHandler(response, values, { resetForm }) {
      check.typeError = "ECHOUE";
      check.idTransaction = response.transactionId;
      check.typeError = "RAS";
      check.idTransaction = response.transactionId;

      values["idTransaction"] = check.idTransaction;
      values["check"] = check;
      // Bloc de code à exécuter lorsque le paiement est un succès
      if (check.typeError === "RAS") {
        // Appel de la fonction addAbonnement et attente de son exécution
        await finishStep(values, { resetForm });
      }
      // Retourne les données après l'exécution
      return { check, response };
    }

    const payer = async (values, { resetForm }) => {
      valideEtape1.value = false;
      valideEtape2.value = false;
      valideEtape3.value = false;
      values["reference"] = reference?.value ?? null;
      values["montant"] = montant?.value ?? null;
      values["totalMoisDu"] = donnee.value ? donnee.value.nombreTotalUsager : null;
     // values["contrat"] = contrat?.value?.id ?? null;
      values["mois"] = mois?.value ?? null;
      values["datePaiement"] = new Date();
      values["mode"] = parseInt(choix?.value ?? "0");
      values["arrieres"] = donnee.value ? donnee.value.arrieres : null;
      values["loyer"] = loyer?.value ?? null;
      if (!values.reference) {
        error("Veuillez saisir une référence valide.");
        valideEtape3.value = true;
        return;
      }
      if (!values.montant) {
        error(
          "Veuillez renseigner un mois et avoir renseigné un numéro de place valide."
        );
        valideEtape3.value = true;
        return;
      }
      if (!values.mode) {
        error("Veuillez choisir un mode de paiement valide.");
        valideEtape3.value = true;
        return;
      }
      if (!values.loyer) {
        error("Veuillez choisir votre place.");
        valideEtape3.value = true;
        return;
      }
      if (!values.contrat) {
        error("Veuillez renseigner un numéro de place valide.");
        valideEtape3.value = true;
        return;
      }
      if (!values.mois) {
        error("Veuillez choisir un mois valide.");
        valideEtape3.value = true;
        return;
      }
      if (values.mode == 1) {
        try {
          const result = await Swal.fire({
            text:
              "Vous êtes sur le point de faire un paiement d'une somme de " +
              values.montant +
              " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            values["check"] = KKIAPAY.check;
            await finishStep(values);
          }
          valideEtape3.value = true;
        } catch (error) {
          //
          valideEtape3.value = true;
        }
      }
      if (values.mode == 2) {
        try {
          const result = await Swal.fire({
            text:
              "Vous êtes sur le point de faire un paiement d'une somme de " +
              values.montant +
              " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            KKIAPAY.kkia(values.montant);
            // Écoute des événements
            addKkiapayListener("failed", (event) => {
              failHandler(event, values, { resetForm });
              // Actions à prendre après l'échec
              console.log("Opération échouée.");
            });

            addKkiapayListener("success", (event) => {
              successHandler(event, values, { resetForm });
              // Actions à prendre après le succès
            });

            const checkRef = toRef(check);
            let resolved = false;

            // Vérification en continu de l'état
            const intervalId = setInterval(() => {
              if (!resolved && checkRef.value.typeError !== "RAS") {
                clearInterval(intervalId);
                resolved = true;
                // Actions à prendre après détection d'une erreur
              }
            }, 500);
          }
        } catch (error) {
          //
          valideEtape3.value = true;
        }
      }
    };
    const activite = ref();
    const exploitant = ref();
    const lesArrieres = ref([]);

    const information = async (referen = "") => {
      try {
        arrieres.value = [];
        const response = await axios.post("/infos", { referen });
        if (response.data.data.length > 0) {
          //contrat.value = response.data.data;
          contrats.value = response.data.data;
          exploitant.value = contrats.value[0].exploitant;
          activite.value = contrats.value[0]?.activite;
        }
        valideEtape1.value = true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
        valideEtape1.value = true;
      }
    };
    const somRedevance = ref(0);
    const loyer = ref(0);
    const choix = ref();
    const arrieres = ref([]);
    const months = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];
    const nombreTotalUsager = ref(0);

    const nextStep = async (stepp = 0) => {
      if (stepp === 1) {
        valideEtape1.value = false;
        arrieres.value = [];
        lesArrieres.value = [];
        if (!reference.value) {
          error("Veuillez d'abord saisir la référence");
          return;
        } else {
          await information(reference.value);
          if (contrats.value < 0) {
            loyer.value = 0;
            error("Veuillez vous rapprocher de la SOGEMA pour mettre à jours vos informations");
            return;
          } else {
            contraOptions.value = contrats.value.map((item) => {
              return {
                value: item.id,
                label: item.ncodeEmp,
                montant: item.loyer,
              };
            });
            for (const contrat of contrats.value) {
              arrieres.value = [];
              somRedevance.value = 0;
              nombreTotalUsager.value = 0;
              for (var arr of contrat?.arrieres) {
                if (arr.annee == new Date().getFullYear()) {
                  arr["anneeEncour"] = true;
                  const moisRestantAnnee = 12 - nomBreMoisAnneeEntame();
                  if (moisRestantAnnee < arr.mois) {
                    nombreTotalUsager.value = parseInt(
                      arr.mois - moisRestantAnnee
                    );
                  }
                  const moiss = getMonthsWithinRange(arr.mois);
                  //const mois = recuperLesMoisDu(arr.mois);
                  if (moiss.length > 0) {
                    //const mois = recuperLesMoisDu(arr.mois);
                    var leMoi = arr.mois;
                    if (!moiss.includes(months[new Date().getMonth()])) {
                      affiche.value = true;
                    }
                    for (const m of moiss) {
                      arr["mois"] = leMoi;
                      arr["moisDu"] = 1;
                      arr["moisDette"] = m;
                      if (months[new Date().getMonth()] == m) {
                        arr["moisEnCours"] = true;
                      } else {
                        arr["moisEnCours"] = false;
                      }
                      leMoi -= 1;
                      arrieres.value.push({ ...arr });
                    }
                  } else {
                    arr["moisDu"] = arr.mois;
                    arrieres.value.push({ ...arr });
                    //nombreTotalUsager.value += parseInt(arr.moisDu);
                  }
                } else {
                  arr["anneeEncour"] = false;
                  arr["moisDu"] = arr.mois;
                  nombreTotalUsager.value += parseInt(arr.moisDu);
                  arrieres.value.push({ ...arr });
                }
              }
              if (arrieres.value.length > 0) {
                somRedevance.value = arrieres.value.reduce(
                  (acc, curr) =>
                    acc +
                    (curr.moisDette
                      ? parseFloat(curr.taux)
                      : parseFloat(curr.taux) * parseFloat(curr.mois)),
                  0
                );
              }
              if (arrieres.value.length > 0) {
                lesArrieres.value.push({
                  nombreTotalUsager:nombreTotalUsager.value,
                  code: contrat.ncodeEmp,
                  id: contrat.id,
                  loyer: contrat.loyer,
                  arrieres: arrieres.value,
                  somRedevance: somRedevance.value
                })
              }
            }
          }
        }
      }
      if (stepp === 2) {
        if (arrieres.value.length < 1) {
          valideEtape1.value = false;
          error("Vous n'avez aucun impayé");
          return;
        }
      }
      stepper.value.next();
    };

    const previousStep = () => {
      stepper.value.previous();
    };

    const choixMode = (mode = "") => {
      choix.value = mode;
    };

    const calculeMontant = () => {
      if (loyer.value != 0) {
        montant.value = loyer.value * mois.value;
      } else {
        Swal.fire({
          title: "Erreur",
          text: "Veuillez saisir un loyer valide.",
          icon: "error",
          toast: true,
          timer: 5000,
          position: "top-right",
          showConfirmButton: false,
        });
        return;
      }
    };
    watch(mois, (newValue, oldValue) => {
      if (newValue != oldValue) {
        mois.value = newValue;
        calculeMontant();
        mois.value = newValue;
      }
    });

    watch(contr,async (newValue, oldValue) => {
      if (newValue != oldValue && newValue) {
        donnee.value = lesArrieres.value.find((item) => item.id == newValue);
        loyer.value = donnee.value.loyer;
        if(mois.value){
          await calculeMontant();
        }
      }
    });

    const openAndPrint = (url = "") => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data) {
      openAndPrint(getUrlApiForFiles("Recu", data + ".pdf"));
    }

    const finishStep = async (values, { resetForm }) => {
      try {
        const response = await axios.post("usagers/paiement", values);
        if (response.data.code == 201) {
          const data = response.data;
          success(response.data.message);
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "UsagerPaiementPage" });
            const maFonction = async () => {
              const result = await Swal.fire({
                html: `<div>Cliquer sur le bouton Aperçu ci-dessous pour avoir un aperçu de votre document</div>`,
                icon: "success",
                buttonsStyling: true,
                confirmButtonText: "Aperçu",
                showCancelButton: false,
                cancelButtonText: `Fermer`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                heightAuto: false,
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-warning",
                },
              });

              if (result.isConfirmed) {
                openNewWindow(data.data[data.data.length - 1]);
              }
            };

            setTimeout(maFonction, 3000);
          } else {
            error(data.message);
          }
        }
        valideEtape1.value = true;
      } catch (error) {
        console.error(error);
        valideEtape1.value = true;
      }
      // Ajoutez ici la logique de traitement après le paiement
    };

    onMounted(() => {
      stepper.value = new Stepper(document.querySelector("#stepper"), {
        linear: false,
        animation: true,
      });
    });

    const soumission = async (values) => {
      try {
        //
      } catch (error) {
        console.error(error);
      }
    };

    const isFading = ref(false);
    let intervalId = null;
    const affiche = ref(false);

    // Style réactif de l'alerte
    const alertStyle = computed(() => ({
      opacity: isFading.value ? 0 : 1,
      transition: "opacity 0.5s ease",
    }));

    // Démarrer le clignotement
    const startBlinking = () => {
      intervalId = setInterval(() => {
        isFading.value = !isFading.value;
      }, 5000); // Clignote toutes les 1000 ms
    };

    // Nettoyer l'effet à la destruction
    const stopBlinking = () => {
      clearInterval(intervalId);
    };

    // Démarrer automatiquement à l'initialisation
    onMounted(() => {
      startBlinking();
    });

    // Nettoyer lors de la destruction du composant
    onBeforeUnmount(() => {
      stopBlinking();
    });

    return {
      soumission,
      reference,
      paiementSchema,
      nextStep,
      previousStep,
      finishStep,
      somRedevance,
      arrieres,
      mois,
      payer,
      choix,
      loyer,
      affiche,
      montant,
      months,
      choixMode,
      contrat,
      alertStyle,
      valideEtape1,
      valideEtape2,
      valideEtape3,
      contraOptions,
      exploitant,
      activite,
      contr,
      lesArrieres,
    };
  },
};
</script>
<style>
/* Ajoutez vos styles personnalisés ici si nécessaire */

p {
  margin: 0 !important;
}
</style>